export class GridFilterBase<T> {
  term: string;

  constructor(public status: T = null) {}
}
